"use client"
import TrackStatus from "@/components/status/TrackApplication";
import React from "react";

export default function ApplicationStatus() {
  return <TrackStatus />;
}
